import moment from "moment";
import { select_access_token } from "./TokenConn";
import { Fn_activeAxios } from "../function/FnConfig";

// 주문 목록 조회
export function api_end_order_list(rootStore) {
  const { searchStore, endOrderStore, settingStore } = rootStore;

  if (!settingStore.getUserInfo.userId || !settingStore.getUserInfo.userNm) {
    settingStore.setUserInfo("userId", localStorage.getItem("userId"));
    settingStore.setUserInfo("userNm", localStorage.getItem("userNm"));
  }

  let startVal = endOrderStore.getEndDateVal.start_val ? endOrderStore.getEndDateVal.start_val : new Date();
  let endVal = endOrderStore.getEndDateVal.start_val ? endOrderStore.getEndDateVal.end_val : new Date();
  let data = JSON.stringify({
    ...searchStore.getShopCdSaleDate,
    startDate: moment(startVal, "YYYYMMDDHHmmss").format("YYYYMMDD"),
    endDate: moment(endVal, "YYYYMMDDHHmmss").format("YYYYMMDD"),
    searchKey: endOrderStore.getEndSearchKeyVal.key,
    searchVal: endOrderStore.getEndSearchVal,
    searchOrderType: endOrderStore.getDetailButtonView,
    viewOrder: settingStore.getOrderViewOrder, // 정렬 순서
    pageNo: endOrderStore.getEndOrderPaging.end_page_no, // 현재 페이지
    userId: settingStore.getUserInfo.userId,
    userNm: settingStore.getUserInfo.userNm,
  });
  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/search_end_main_list", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
            
          const data = res.data.data;
          endOrderStore.setEndOrderList(data.list);
          endOrderStore.setAfterDetailUpdate();
          endOrderStore.setEndOrderPagingInfo("end_max_page", Number(data.maxPage));
        }
      }
    })
    .catch(err => {});
}

// 주문이 존재하는 페이지 조회(완료주문건)
export async function api_end_order_list_paging(rootStore, mobileOrderNo) {
  let data = JSON.stringify({
    mobileOrderNo: mobileOrderNo,
    saleDate: rootStore.searchStore.getShopCdSaleDate.saleDate,
    shopCd: rootStore.searchStore.getShopCd,
  });

  const api = Fn_activeAxios(rootStore);
  let res = await api
    .post("/gate/okgo/search_order", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data) {
            rootStore.endOrderStore.setEndOrderList(data);
            return true;
          }
        }
      }
    })
    .catch(err => {
      return false;
    });
  return res;
}

// 주문 목록 갱신
export function reload_end_order_list(rootStore) {
  select_access_token(rootStore).then(res => {
    api_end_order_list(rootStore);
  });
}
